import type { SVGProps } from 'react'

export const SignalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M5.38268 10.2321C3.93665 8.7861 3.93665 6.44163 5.38268 4.99561M10.6192 4.99561C12.0652 6.44163 12.0652 8.7861 10.6192 10.2321M3.28807 12.3267C0.685226 9.72389 0.685226 5.50385 3.28807 2.901M12.7138 2.901C15.3166 5.50385 15.3166 9.72389 12.7138 12.3267M8.00094 7.61387H8.00834V7.62127H8.00094V7.61387ZM8.37122 7.61387C8.37122 7.81837 8.20544 7.98415 8.00094 7.98415C7.79644 7.98415 7.63066 7.81837 7.63066 7.61387C7.63066 7.40937 7.79644 7.24359 8.00094 7.24359C8.20544 7.24359 8.37122 7.40937 8.37122 7.61387Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.99957 7.61396V14.8362" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
